export enum ActionEnum {
  add = 'add',
  parse = 'parse',
  remove = 'remove',
  select = 'select',
  updateTab = 'updateTab',
}
